<template>
  <div>
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-lg max-h-full bg-white shadow-lg rounded-lg p-5 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>
        <div class="flex flex-wrap">
          <div
            v-if="!newFormCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Actualización de proyecto</div>
          <div
            v-if="newFormCategory"
            class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
          >Nuevo Proyecto</div>

          <div class="flex flex-col w-full pl-4">
            <form class="w-full max-w-lg" id="formCategoryForm" @submit.prevent>
              <div class="flex flex-wrap -mx-3">
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="name_category"
                  >Nombre *</label>
                  <input
                    :class="{'border-red-500': errors.name_category}"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="name_category"
                    type="text"
                    name="name_category"
                    v-model="formCategory.category_name"
                  />
                  <p
                    v-if="errors.name_category"
                    class="text-red-500 text-xs italic"
                  >Ingrese un nombre para el proyecto.</p>
                </div>
                <div class="w-full px-3 mb-6 md:mb-0">
                  <label
                    class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                    for="place_category"
                  >Lugar *</label>
                  <input
                    :class="{'border-red-500': errors.place_category}"
                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                    id="place_category"
                    type="text"
                    name="place_category"
                    v-model="formCategory.category_place"
                  />
                  <p
                    v-if="errors.place_category"
                    class="text-red-500 text-xs italic"
                  >Ingrese un lugar para el proyecto.</p>
                </div>
              </div>

              <div class="flex w-full justify-end">
                <button
                  class="bg-blue-500 hover:bg-blue-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="saveCategory()"
                >Guardar</button>
                <button
                  class="ml-2 bg-red-500 hover:bg-red-700 px-4 py-2 text-center rounded-lg text-gray-100 tracking-wide"
                  @click="close()"
                >Cerrar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <alert-dialog :showing="showingSuccess">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Proyecto guardado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-green-400"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccess = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">{{errors.codeError}}</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-red-400"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import config from "../../vue.config.js";
import { backend_url } from "../config/url.config.ts";
import EventBus from "../event-bus";
import AlertDialog from "./AlertDialog";

export default {
  name: "form-category-modal",
  data() {
    return {
      aux_formCategory: null,
      formCategory: {
        category_name: null,
        category_place: null,
        enable: null,
        id: null
      },
      errors: {
        name_category: false,
        place_category: false,
        codeError: "Ha ocurrido un error"
      },
      showingSuccess: false,
      showingError: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      }
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    newFormCategory: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  mounted() {
    EventBus.$on("editModal", this.setData);
  },
  components: {
    AlertDialog
  },
  methods: {
    reset: function() {
      this.formCategory = {
        category_name: null,
        category_place: null,
        enable: null,
        id: null
      };
      this.errors = {
        name_category: false,
        place_category: false,
        codeError: "Ha ocurrido un error"
      };
    },

    close() {
      this.reset();
      this.$emit("close");
    },

    setData: function(category) {
      //console.log("setData", category)
      //this.formCategory = Object.assign({}, category);
      

      this.formCategory.id = category.id
      this.formCategory.category_name = category.nombre
      this.formCategory.category_place = category.lugar

      this.aux_formCategory = Object.assign({}, this.formCategory);

      //console.log(this.formCategory)
    },

    saveCategory() {
      const form = document.getElementById("formCategoryForm");
      const signInData = new FormData(form);

      if (this.newFormCategory) {
        const validForm = this.checkFormCategoryForm(signInData);
        if (validForm) {
          this.axios
            .post(
              backend_url + "/api/ppd/proyectos/newProject",
              {
                nombre: this.formCategory.category_name,
                lugar: this.formCategory.category_place
              },
              this.config
            )
            .then(response => {
              return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Creación de un proyecto", 
                "observation": this.formCategory.category_name,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(response => {
              this.showingSuccess = true;
              this.$emit("updateAllFormCategories");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              console.error(error.response);
              if (error.response.status == 409) {
                this.errors.codeError =
                  "Ya hay otro proyecto con ese nombre. Pruebe con otro nombre";
              }

              if (error.response.status == 400 || error.response.status == 401) {
                if (error.response.data.name === 'TokenExpiredError' || 
                    error.response.data.name === 'InvalidTokenError' || 
                    error.response.data.name === 'JsonWebTokenError') {
                this.$router.push({path: '/login'}); 
                }
              }
              this.showingError = true;
            });
        }
      } else {
        const validForm = this.checkFormUpdateFormCategory(signInData);
        if (validForm) {
          this.axios
            .put(
              backend_url + "/api/ppd/proyectos/updateProject/" + this.formCategory.id,
              {
                nombre: this.formCategory.category_name,
                lugar: this.formCategory.category_place,
                enabled: this.formCategory.enabled
              },
              this.config
            )
            .then(response => {
              let observation = ""
              if(this.formCategory.category_name != this.aux_formCategory.category_name){
                observation = `${this.aux_formCategory.category_name} / ${this.formCategory.category_name}`
              } else {
                observation = `${this.formCategory.category_name}`
              }

              return this.axios.post(backend_url+"/api/binnacles/monitor/save/",{
                "module": "Configuración", 
                "action": "Edición de un proyecto", 
                "observation": observation,
                "email": localStorage.getItem("email")
                },
                this.config
              )
            })
            .then(response => {
              this.showingSuccess = true;
              this.$emit("updateFormCategoryModal");
              this.reset();
              this.$emit("close");
            })
            .catch(error => {
              console.error(error.response);
              if (error.response.status == 400 || error.response.status == 401) {
                if (error.response.data.name === 'TokenExpiredError' || 
                    error.response.data.name === 'InvalidTokenError' || 
                    error.response.data.name === 'JsonWebTokenError') {
                this.$router.push({path: '/login'}); 
                }
              }
              this.showingError = true;
            });
        }
      }
    },

    checkFormCategoryForm: function(signInData) {
      if (signInData.get("name_category") === "") {
        this.errors.name_category = true;
      } else {
        this.errors.name_category = false;
      }

      if (signInData.get("place_category") === "") {
        this.errors.place_category = true;
      } else {
        this.errors.place_category = false;
      }

      if (this.errors.name_category) {
        return false;
      }

      if (this.errors.place_category) {
        return false;
      }

      return true;
    },

    checkFormUpdateFormCategory: function(signInData) {
      if (signInData.get("name_category") === "") {
        this.errors.name_category = true;
      } else {
        this.errors.name_category = false;
      }

      if (signInData.get("place_category") === "") {
        this.errors.place_category = true;
      } else {
        this.errors.place_category = false;
      }

      if (this.errors.name_category) {
        return false;
      }

      if (this.errors.place_category) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
.text-teal-700 {
  color: #6e5b25;
}
</style>
